import Icon from '../components/Icon.vue'

Icon.register({
  blender: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 384H160C124.7 384 96 412.6 96 448V480C96 497.7 110.3 512 128 512H448C465.7 512 480 497.7 480 480V448C480 412.6 451.4 384 416 384zM288 480C270.3 480 256 465.7 256 448S270.3 416 288 416 320 430.3 320 448 305.7 480 288 480zM328 64H494.5L512 0H48C21.5 0 0 21.5 0 48V208C0 234.5 21.5 256 48 256H151.3L160 352H416L433.5 288H328C323.6 288 320 284.4 320 280V264C320 259.6 323.6 256 328 256H442.2L459.6 192H328C323.6 192 320 188.4 320 184V168C320 163.6 323.6 160 328 160H468.4L485.8 96H328C323.6 96 320 92.4 320 88V72C320 67.6 323.6 64 328 64zM64 192V64H133.8L145.5 192H64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/blender.js
// module id = IoEw
// module chunks = 144